export default __webpack_public_path__ + "static/3-panic-defer-d8f54a06eac00222b5c7ed1a75298442.png";